import React from 'react';
import styles from './Loading.module.scss';

const Loading = () => {
    return (
        <div className={styles.container}>
            <div id={'loading-text'} className={styles.text}>
                Loading....
            </div>
        </div>
    );
};

export default Loading;
